import users from '@/api/apiUsersManagement/services/users'
import session from '@/auth/session'

export const getList = ({ commit, state, getters, dispatch }) => {
  dispatch('loading')
  return new Promise((resolve, reject) => {
    let params = {}
    if (state.username) params.username = state.username
    if (state.role) params.role = state.role
    if (state.email) params.email = state.email
    if (state.active) params.active = state.active
    if (state.search.limit) params.limit = state.search.limit
    users.list(session.getUserId(), params)
    .then((res) => {
      commit('list/SET_LIST', res.data)
      commit('search/SET_MORE', res.headers['x-next-page'])
      resolve(res.data)
      dispatch('loaded')
    })
  })
}

export const getMore = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    users.listMore(state.search.more)
    .then((res) => {
      if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
        reject(new Error('Error de conexión'))
        return
      }
      commit('list/ADD_TO_LIST', res.data)
      commit('search/SET_MORE', res.headers['x-next-page'])
      resolve(res.data)
    })
  })
}

export const resetParams = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_USERNAME', '')
    commit('SET_ROLE', '')
    commit('SET_EMAIL', '')
    commit('SET_ACTIVE', '')
    commit('search/SET_MORE', undefined)
    commit('search/SET_LIMIT', 10)
    commit('search/SET_SORT', undefined)
    resolve()
  })
}

export const remove = ({ commit, dispatch }, selected) => {
  return new Promise((resolve, reject) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      users.remove(selected.map(x => x.id)).then((res) => {
        resolve(res)
      })
    })
  })
}

export const loading = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', false)
    resolve(false)
  })
}

export const loaded = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', true)
    resolve(true)
  })
}
